'use client';

import Link from 'next/link';
import { trackCTAClick } from '@/lib/analytics';
import useScrollReveal from '@/hooks/useScrollReveal';

export default function CTASection() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollReveal<HTMLElement>();

  return (
    <section ref={sectionRef} className="py-12 sm:py-16 md:py-20 lg:py-28 bg-brand-plum">
      <div className={`max-w-4xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 text-center transition-all duration-1000 ${sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <h2 className="font-headline text-2xl sm:text-3xl md:text-4xl text-white mb-3 sm:mb-4 font-bold leading-tight">
          Ready to Stop Competing on Price?
        </h2>
        <p
          className="font-body text-sm sm:text-base md:text-lg text-white/90 mb-6 sm:mb-8 leading-relaxed px-4"
          style={{ transitionDelay: '200ms' }}
        >
          We work with founders who are done with shortcuts and ready to build the real infrastructure that separates professionals from amateurs. If that's you, let's talk.
        </p>
        <Link
          href="/contact"
          onClick={() => trackCTAClick('Start the Conversation', 'CTA Section - Homepage')}
          className="group inline-flex items-center gap-3 sm:gap-4 px-8 sm:px-10 md:px-12 py-4 sm:py-5 md:py-6 bg-brand-teal text-white font-body font-bold text-base sm:text-lg md:text-xl rounded-xl hover:bg-brand-green hover:shadow-hover transition-all duration-300 shadow-button transform hover:scale-105 active:scale-95 active:shadow-md min-h-[44px]"
        >
          <span className="flex items-center gap-2 sm:gap-3">
            Start the Conversation
            <span className="text-base sm:text-lg">→</span>
          </span>
        </Link>
      </div>
    </section>
  );
}